import type { ReactNode } from 'react'

interface RtkQueryErrorShape {
  status?: number
  data?: unknown
}

export function proxyApiErrorMessage(error: unknown, fallback: string): string {
  const data = (error as RtkQueryErrorShape | undefined)?.data
  if (typeof data === 'object' && data !== null) {
    for (const key of ['message', 'error'] as const) {
      const msg = (data as Record<string, unknown>)[key]
      if (typeof msg === 'string' && msg.length > 0) return msg
    }
  }
  if (error instanceof Error && error.message) return error.message
  return fallback
}

interface SectionProps {
  label: string
  hint?: string
  /** Optional header-right controls (e.g. an Edit button). */
  actions?: ReactNode
  children: ReactNode
}

export function Section({ label, hint, actions, children }: SectionProps) {
  return (
    <section className="flex flex-col gap-3">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="min-w-0 flex-1">
          <h2 className="m-0 text-sm font-semibold text-ink">{label}</h2>
          {hint && <p className="mt-0.5 m-0 text-xs text-ink-4">{hint}</p>}
        </div>
        {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
      </div>
      {children}
    </section>
  )
}
